export default __webpack_public_path__ + "static/media/maintenance.fbac1915.svg";